import React, { Component } from 'react';
import { connect } from 'react-redux';

import { SEARCH_TERM, START_DATE, END_DATE } from '../../actions/index';
import ViewButtons from './view-buttons';
import { PER_PAGE } from '../../actions/index';

class SearchForm extends Component {
	constructor( props ) {
		super( props );
		this.handleChange = this.handleChange.bind( this );
	}

	handleInputSearchChange( event ) {
		event.preventDefault();
		if ( this.props.searchTerm !== event.target.value ) {
			this.props.dispatch( {
                 type   : SEARCH_TERM,
                 payload: event.target.value
             } );
		}
	}

	handleChange( event ) {
		this.props.dispatch( {
             type   : PER_PAGE,
             payload: event.target.getAttribute( 'data-count' )
         } );
	}

	renderLimitCountOptions() {
		const options = [ 12, 36, 64 ];
		return options.map( option => {
			return (<li key={ option }>
				<button type="button"
				        name={ 'display-' + option }
				        data-count={ option }
				        onClick={ this.handleChange }>Display { option }</button>
			</li>
			);
		} );
	}

	findCategoryFromSlug( slug ) {
		return ISDA_Main.categories.find( category => category.slug === slug );
	}

	clearFilters( event ) {
		event.preventDefault();
		this.props.dispatch( {
			                     type: SEARCH_TERM, payload: ''
		                     } );
		this.props.dispatch( {
			                     type: START_DATE, payload: ''
		                     } );
		this.props.dispatch( {
			                     type: END_DATE, payload: ''
		                     } );
	}

	submit( event ) {
		event.preventDefault();
	}

	render() {
		return (
			<div className="sorting-bar" id="archive-sorting-bar">
				{/*<form onSubmit={ this.submit } className="inner-page-search form-inline" id="category-filter-form">*/}
				{/*	<div className="row">*/}
				{/*		<div className="dropdown col-md-3">*/}
				{/*			<button className="btn btn-default dropdown-toggle" type="button" id="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">*/}
				{/*				Displaying { this.props.posts.length } of { this.props.pagination.totalResults }<span className="caret"></span>*/}
				{/*			</button>*/}
				{/*			<ul className="dropdown-menu" aria-labelledby="">*/}
				{/*				{ this.renderLimitCountOptions() }*/}
				{/*			</ul>*/}
				{/*		</div>*/}
				{/*		<div className="form-group-keyword form-group col-xs-8 col-md-4 col-md-offset-1">*/}
				{/*			<label htmlFor="archive-keyword-filter" className="sr-only">Keyword Filter</label>*/}
				{/*			<input type="search"*/}
				{/*			       value={ this.props.searchTerm }*/}
				{/*			       onChange={ this.handleInputSearchChange.bind( this ) }*/}
				{/*			       id="archive-keyword-filter"*/}
				{/*			       className="form-control"*/}
				{/*			       placeholder={ `Filter by keyword` } />*/}
				{/*		</div>*/}
				{/*		<div className="form-group-clear col-xs-4 col-md-2 nopadding">*/}
				{/*			<button type="button" id="" className="btn-clear-inner-search" onClick={ this.clearFilters.bind( this ) } name="Clear all search filters">*/}
				{/*				<span className="glyphicon glyphicon-remove" aria-hidden="true"></span>*/}
				{/*				Clear filters*/}
				{/*			</button>*/}
				{/*		</div>*/}
				{/*		<ViewButtons categorySlug={this.props.categorySlug} />*/}
				{/*	</div>*/}
				{/*</form>*/}
			</div>
		);
	}
}

function mapStateToProps( { searchTerm, pagination, posts } ) {
	return { searchTerm, pagination, posts };
}

export default connect( mapStateToProps )( SearchForm );